module.exports = __webpack_public_path__ + "static/media/ticketNormal.3baa5e9d.svg";